import { render, staticRenderFns } from "./StudyGruop.vue?vue&type=template&id=a1d888e6&scoped=true&"
import script from "./StudyGruop.vue?vue&type=script&lang=js&"
export * from "./StudyGruop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d888e6",
  null
  
)

export default component.exports